import LightModal from './LightModal'

export default LightModal
